import { isArray } from '@/modules/shared/helpers/utils/utils'

export function fileFilter<Type>(data) {
  if (data) {
    if (isArray(data)) {
      return (data as Array<Type>).filter(item => item instanceof File)
    } else {
      return (data instanceof File) ? [data] : []
    }
  }
  return []
}